//@ts-nocheck
import { Box } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React, { FC } from "react";
import { ISubjectStore, ITuteriaSubject, ITutorSubject } from "../../stores";
import ResultsPage from "../../tutor-revamp/Results";
import { displayToast } from "../forms/SharedComponents";
import QuizSelectionView from "../QuizSelectionView";
import QuizPage from "./QuizPage";
import { IQuizStore } from "./quizStore";

const Quiz: FC<{
  store: IQuizStore;
  quizName: string;
  hasCompletedQuiz: boolean;
  onNavigate: () => void;
  onSubmitQuiz: () => Promise<any>;
  canRetakeTest?: boolean;
  retakeTest: () => void;
  navigateToSubject: () => void;
  canEditSubject?: boolean;
}> = ({
  store,
  quizName,
  hasCompletedQuiz,
  onNavigate,
  onSubmitQuiz,
  canRetakeTest = false,
  retakeTest = () => {},
  navigateToSubject = () => {},
  canEditSubject = true,
}) => {
  const handleBeforeUnload = (event) => {
    const e = event || window.event;
    e.preventDefault();
    if (e) {
      e.returnValue = "";
    }
    return "";
  };

  const handleUnload = async (event) => {
    await onSubmitQuiz();
  };

  const handleBackButtonClick = async () => {
    const reply = confirm(
      "You've not completed your test. Going back will end and submit this test. Are you sure you want to exit?",
    );
    if (reply == true) {
      await onSubmitQuiz();
      history.back();
    } else {
      history.pushState(null, null, window.location.pathname);
    }
    history.pushState(null, null, window.location.pathname);
  };
  React.useEffect(() => {
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("unload", handleUnload);
    window.addEventListener("popstate", handleBackButtonClick);
    if (hasCompletedQuiz) {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handleBackButtonClick);
      window.removeEventListener("unload", handleUnload);
    }
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handleBackButtonClick);
    };
  }, [hasCompletedQuiz]);

  return (
    <Box>
      {hasCompletedQuiz ? (
        <Box maxW={["100%", "100%", "640px"]} mx="auto">
          <ResultsPage
            subject={quizName}
            totalQuestions={store.quiz.questions.length}
            quizResults={store.quizResults}
            navigate={canRetakeTest ? retakeTest : onNavigate}
            canRetakeTest={canRetakeTest}
            navigateToSubject={navigateToSubject}
            canEditSubject={canEditSubject}
          />
        </Box>
      ) : (
        <QuizPage
          subject={quizName}
          completed={hasCompletedQuiz}
          onQuizSubmit={onSubmitQuiz}
          index={0}
          store={store}
        />
      )}
    </Box>
  );
};

export const TuteriaQuizPage: React.FC<{
  store: ITutorSubject;
  subjectStore: ISubjectStore;
  canTakeQuiz: boolean;
  subjectInfo: ITuteriaSubject;
  isLiteTutor?:boolean;
  navigateToSubject: any;
  toSubjectEditPage: any;
  isReview?: boolean;
  canEditSubject?: boolean;
}> = observer(
  ({
    store,
    subjectStore,
    subjectInfo,
    canTakeQuiz,
    navigateToSubject,
    toSubjectEditPage,
    isLiteTutor=false,
    isReview = false,
    canEditSubject = true,
  }) => {
    const [testPreview, startTest] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [quizzes, setQuizzes] = React.useState([]);

    const canRetakeTest = store.quizStore.quizResults.passedQuiz
      ? false
      : store.withinTimeWindow && store.totalAttempts < 3;

    const onNextClick = async (selectedQuizzesToTake) => {
      try {
        console.log(selectedQuizzesToTake);
        setLoading(true);
        const response = await store.buildQuiz(
          subjectInfo,
          selectedQuizzesToTake.map((z) =>
            subjectInfo.subjects.find((o) => o.name === z),
          ),
        );
        setQuizzes(response);
        // await store.updateQuizAttempts();
        await store.beginQuiz(subjectInfo);
        startTest(true);
        setLoading(false);
      } catch (error) {
        console.log(error);
        console.log(error);
        setLoading(false);
        displayToast({
          status: "error",
          title: "",
          duration: 4000,
          position: "top",
          description: "Oops! There was a problem. Please try again",
        });
      }
    };

    const onRefreshClick = async (selectedQuizzesToTake) => {
      try {
        setLoading(true);
        const response = await store.onRefresh(
          selectedQuizzesToTake.map((z) =>
            subjectInfo.subjects.find((o) => o.name === z),
          ),
        );
        setLoading(false);
        displayToast({
          status: "success",
          title: "Success",
          duration: 4000,
          position: "top",
          description: "Refresh successful",
        });
      } catch (error) {
        setLoading(false);
        displayToast({
          status: "error",
          title: "Error",
          duration: 4000,
          position: "top",
          description: "Oops! There was a problem. Please try again",
        });
      }
    };

    const clearQuiz = () => {
      store.clearQuizStore();
      startTest(false);
    };

    return testPreview ? (
      <Quiz
        store={store.quizStore}
        quizName={subjectInfo.name}
        onSubmitQuiz={() => store.handleQuizSubmission(quizzes, subjectStore)}
        hasCompletedQuiz={store.quizStore.completed}
        onNavigate={() => {
          store.updateTestStatus(store.quizStore.quizResults.passedQuiz);
          if (store.quizStore.quizResults.passedQuiz) {
            toSubjectEditPage();
          } else {
            navigateToSubject();
          }
        }}
        canRetakeTest={canRetakeTest}
        retakeTest={() => {
          store.updateTestStatus(store.quizStore.quizResults.passedQuiz);
          clearQuiz();
        }}
        navigateToSubject={() => {
          store.updateTestStatus(store.quizStore.quizResults.passedQuiz);
          clearQuiz();
          navigateToSubject();
        }}
        canEditSubject={canEditSubject}
      />
    ) : (
      <QuizSelectionView
        generateQuiz={onNextClick}
        isLiteTutor={isLiteTutor}
        canTakeQuiz={canTakeQuiz}
        testSubject={subjectInfo.name}
        subjectInfo={subjectInfo}
        testableSubjects={subjectInfo.subjects.map((o) => o.name)}
        toSubjectPage={navigateToSubject}
        loading={loading}
        isReview={isReview}
        onRefresh={onRefreshClick}
      />
    );
  },
);

export default Quiz;
